export default "__VITE_ASSET__FsGU9dcG__"